<template>
  <div class="page">
    <Banner :top="0" />
    <div class="pc_ipad">
      <div class="layer1">
        <div class="left">
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-neo/1.png"
                alt=""
              >
            </div>
            <div>
              <img
                src="~@/assets/spark-neo/2.png"
                alt=""
              >
            </div>
          </div>
          <div class="row row1">
            <div>
              <img src="~@/assets/spark-neo/3.png">
            </div>
            <div>
              <img src="~@/assets/spark-neo/4.png">
            </div>
          </div>
          <div class="row row1">
            <div>
              <img src="~@/assets/spark-neo/5.png">
            </div>
            <div>
              <img src="~@/assets/spark-neo/6.png">
            </div>
          </div>
        </div>
        <div class="right">
          <div class="box">
            <img
              class="background"
              src="~@/assets/spark-neo/0.png"
            >
            <div class="right_btn_box">
              <!-- <img
                class="price"
                src="~@/assets/spark-live/3999.png"
              > -->
              <img
                class="btn"
                src="~@/assets/spark-neo/0_1.png"
                @click="openTmallFun"
              >
              <img
                class="btn btn_jd"
                src="~@/assets/spark-neo/0_2.png"
                @click="openJDFun"
              >
              <div class="download">
                <a
                  :href="androidUrl"
                  download=""
                  style="cursor:pointer"
                  @click="downloadAndroidFun"
                >
                  <img
                    class="anzuo"
                    src="~@/assets/spark-neo/0_4.png"
                    @click="downloadAndroidFun"
                  >
                </a>
                <img
                  src="~@/assets/spark-neo/0_3.png"
                  @click="downIosFun"
                >
                <!-- <img
                  class="text"
                  src="~@/assets/spark-mini/text.png"
                > -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="layer2"
      >
        <img src="~@/assets/spark-neo/ls2.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls4.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls5.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls6.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls7.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls8.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls9.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls10.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls11.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/ls12.png">
      </div>
    </div>

    <!-- 手机版 -->
    <div class="mobile">
      <vue-carousel
        :data="slides"
        :slide-on-swipe="false"
        class="carousel"
      />
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m1.png">
        <div
          class="tmall"
          @click="openTmallFun"
        >
          <img src="~@/assets/spark-neo/0_1.png">
        </div>
        <div
          class="tmall jd"
          @click="openJDFun"
        >
          <img src="~@/assets/spark-neo/0_2.png">
        </div>
        <a
          :href="androidUrl"
          download=""
          style="cursor:pointer"
          class="anzuo"
          @click="downloadAndroidFun"
        >
          <img src="~@/assets/spark-neo/0_3.png">
        </a>
        <a class="ios">
          <img
            src="~@/assets/spark-neo/0_4.png"
            @click="downIosFun"
          >
        </a>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m2.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m3.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m4.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m5.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m6.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m7.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m8.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m9.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m10.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-neo/mobile/m11.png">
      </div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner'
import VueCarousel from '@chenfengyuan/vue-carousel'
import axios from 'axios'
import { NEW_API_URL } from '@/urls'
import 'swiper/dist/css/swiper.css'
export default {
  components: {
    Banner,
    VueCarousel
  },
  data () {
    let row1 = require('@/assets/spark-neo/1.png')
    let row2 = require('@/assets/spark-neo/2.png')
    let row3 = require('@/assets/spark-neo/3.png')
    let row4 = require('@/assets/spark-neo/4.png')
    let row5 = require('@/assets/spark-neo/5.png')
    let row6 = require('@/assets/spark-neo/6.png')
    return {
      play1: false,
      play2: true,
      play5: true,
      play6: false,
      play7: false,
      play8: true,
      slides: [
        `<div> <img src="${row1}" > </div>`,
        `<div> <img src="${row2}" > </div>`,
        `<div> <img src="${row3}" > </div>`,
        `<div> <img src="${row4}" > </div>`,
        `<div> <img src="${row5}" > </div>`,
        `<div> <img src="${row6}" > </div>`
      ],
      androidUrl: '',
      num: 0,
      swiperOption1: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20,
        // slidesOffsetBefore: '260%',
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2: {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: false,
        spaceBetween: 20,
        initialSlide: 2, // 滑动在第几个开始
        // freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption1mobile: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20, // 图片间隔
        freeMode: true,
        initialSlide: 3, // 滑动在第几个开始
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2mobile: {
        slidesPerView: '1.2',
        loop: false,
        spaceBetween: 0,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2moblie: {
        slidesPerView: '1.3',
        loop: false,
        spaceBetween: 10,
        initialSlide: 3,
        centeredSlides: true,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  watch: {},
  created () {
    this.downloadAndroidFun()
  },
  methods: {
    videoClick1 () {
      this.play1 = !this.$refs.videoPlayer1.paused

      this.$refs.videoPlayer1.paused === true
        ? this.$refs.videoPlayer1.play()
        : this.$refs.videoPlayer1.pause()
    },
    videoClick2 () {
      this.play2 = !this.$refs.videoPlayer2.paused
      this.$refs.videoPlayer2.paused === true
        ? this.$refs.videoPlayer2.play()
        : this.$refs.videoPlayer2.pause()
    },
    videoClick3 () {
      this.play1 = !this.$refs.videoPlayer3.paused

      this.$refs.videoPlayer3.paused === true
        ? this.$refs.videoPlayer3.play()
        : this.$refs.videoPlayer3.pause()
    },
    videoClick5 () {
      this.play5 = !this.$refs.videoPlayer5.paused

      this.$refs.videoPlayer5.paused === true
        ? this.$refs.videoPlayer5.play()
        : this.$refs.videoPlayer5.pause()
    },
    videoClick6 () {
      this.play6 = !this.$refs.videoPlayer6.paused

      this.$refs.videoPlayer6.paused === true
        ? this.$refs.videoPlayer6.play()
        : this.$refs.videoPlayer6.pause()
    },
    videoClick7 () {
      this.play7 = !this.$refs.videoPlayer7.paused

      this.$refs.videoPlayer7.paused === true
        ? this.$refs.videoPlayer7.play()
        : this.$refs.videoPlayer7.pause()
    },
    videoClick8 () {
      this.play8 = !this.$refs.videoPlayer8.paused

      this.$refs.videoPlayer8.paused === true
        ? this.$refs.videoPlayer8.play()
        : this.$refs.videoPlayer8.pause()
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('https://e.tb.cn/h.RUc9Nbxuhdk12TU?tk=4o3m5yV5SWG')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?abbucket=5&id=977524956115&rn=82d32db3a60caba945b214262a93e840&skuId=6056851788335&spm=a1z10.5-b.w4011-23474728918.44.30b23696IWY2ik'
        )
      }
    },
    openJDFun () {
      if (this._isMobile()) {
        window.open('https://3.cn/2PX8-Jxt?jkl=@NEzpmBc8SCY@')
      } else {
        window.open('https://item.jd.com/10184563234505.html?pcdk=tZChQfWjeO-pOTTGNvEyiifhwHo9ngi5-7BTAUuGaaDOBc-JeobU6IPAOn92Wglh.3z6a.aI3x&spmTag=YTAyMTkuYjAwMjM1Ni5jMDAwMDcyMTAua2V5d29yZF9lbnRlciU0MDE3Nzk5NzIzNjU5MzYlMjMxNzY4OTczMzA2MDQyOTA0ODYzMjIwJTIzMTUyNjA5MzEzJTJDYTAyNDAuYjAwMjQ5My5jMDAwMDQwMjcuMSUyM3NrdV9jYXJkJTQwMTc3OTk3MjM3MTQ1NyUyMzE3Njg5NzMzMDYwNDI5MDQ4NjMyMjAlMjM5NTc0MTI2MDI')
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then((res) => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (
                userAgent.indexOf('android') > -1 &&
                                this.num > 1
              ) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch((err) => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    }
  }
}
</script>
<style lang="scss" scoped>
.pc_ipad {
    display: block;
    padding-top: 54px;
}

.mobile {
    display: none;
}

.page {
    // padding-top: 5.5%;
    background: #fff;
    min-height: 100vh;

    .layer1 {
        display: flex;

        .left {
            flex: 1435;
            padding:0 1% 1% 1%;

            .row {
                display: flex;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 10px;
                .video {
                    display: flex;
                    background: #000;
                }
                div:nth-child(1) {
                    margin-right: 1%;
                }

                div {
                    position: relative;
                    flex: 1;
                    max-width: 100%;

                    img,
                    video {
                        width: 100%;
                    }

                    .play {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20%;
                    }
                }
            }

            .row:nth-child(3) {
                margin: 0;
            }
        }

        .right {
            flex: 486;
            // background: #e02020;
            box-sizing: border-box;
            text-align: center;

            .box {
                margin: 0 auto;
                position: relative;

                .background {
                    width: 100%;
                }

                .right_btn_box {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                    padding-top: 110%;

                    .price {
                        width: 80%;
                        margin-left: 10%;
                        margin-bottom: 10%;
                    }

                    .btn {
                        cursor: pointer;
                        width: 83%;
                        margin-left: 9%;
                        height: 5.5%;
                    }
                    .btn_jd {
                        margin-top: 3%;
                    }
                    .download {
                        // opacity: 0;
                        margin-top: 6%;
                        margin-left: 9%;
                        width: 100%;
                        display: flex;
                    }
                    .download > * {
                        width: 35%;
                        margin-right: 5%;
                    }

                    .text {
                        margin: 0 auto;
                        margin-top: 8%;
                        width: 50%;
                    }
                }
            }
        }
    }

    .layer2 {
        position: relative;
        .video {
            position: absolute;
            bottom: 2%;
            right: 10%;
            display: flex;
            width: 40%;
            height: 12.1%;
            box-sizing: border-box;
            margin-bottom: 10px;

            div:nth-child(1) {
                margin-right: 1%;
            }

            img,
            video {
                width: 100%;
            }

            .play {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 20%;
            }
        }
    }

    .layer3 {
        // margin-top: -25%;
    }

    .layer4 {
        position: relative;
        padding: 7% 0;
        .swiper {
            // position: absolute;
            top: 17%;

            .swiper-slide {
                width: 33%;
            }

            .width {
                width: 3%;
            }
        }
    }
    .layer4_1 {
        background-color: #000;
    }

    .layer5 {
        position: relative;

        .swiper {
            position: absolute;
            top: 44%;

            .swiper-slide {
                width: 7%;
            }

            .width {
                width: 13%;
            }
        }
        .swiper2 {
            position: absolute;
            top: 69%;

            .swiper-slide {
                width: 17%;
            }

            .width {
                width: 13%;
            }
        }
    }

    .layer4,
    .layer5 {
        // background-color: #000;
    }

    .layer8 {
        position: relative;

        .swiper {
            position: absolute;
            top: 20%;

            .swiper-slide {
                width: 70%;
            }

            .width {
                width: 95%;
            }
        }
    }

    @media (max-width: 768px) {
        .pc_ipad {
            display: none;
        }

        .mobile {
            min-height: 100%;
            padding-top: 44px;
            background: #fff;
            display: block;

            .carousel {
                height: 100%;
                vertical-align: middle;
            }

            .layer2 > img {
                margin-top: -1px;
            }

            .layer2 {
                position: relative;
                text-align: center;

                .right_btn_box {
                    width: 100%;
                    position: absolute;
                    top: 65%;

                    .btn {
                        margin: 0 auto;
                        width: 56%;
                    }

                    .anzuo {
                        margin: 15% auto 0 auto;
                        width: 45%;
                    }

                    .ios {
                        margin: 3% auto 0 auto;
                        width: 45%;
                    }

                    .text {
                        margin: 3% auto 0 auto;
                        width: 25%;
                    }
                }

                .tmall {
                    padding: 5%;
                    position: absolute;
                    top: 67%;
                    // background-color: #000;
                    // width: 46%;
                    height: 10%;
                }
                .jd {
                    top: 76%;
                }

                .anzuo {
                    position: absolute;
                    top: 88.5%;
                    left: 7%;
                    // background-color: #fff;
                    width: 40%;
                    height: 10%;
                }

                .ios {
                    position: absolute;
                    top: 88.5%;
                    right: 7%;
                    // background-color: #fff;
                    width: 40%;
                    height: 10%;
                }

                .video {
                    position: absolute;
                    bottom: 0%;
                    left: 4%;
                    width: 92%;
                }
                .swiper2moblie {
                    position: absolute;
                    max-width: 100%;
                    bottom: 10%;
                }
            }
            .layer8moblie {
                margin-top: 10%;
            }
            .swiper1 {
                background: #000;
                .swiper-container {
                    background-color: #000;
                }
                .width {
                    width: 0%;
                }
            }

            // .layer3 {
            //     margin-top: 0%;
            //     position: relative;

            //     .play {
            //         position: absolute;
            //         top: 50%;
            //         left: 50%;
            //         transform: translate(-50%, -50%);
            //         width: 20%;
            //     }
            // }
            // .layer14 {
            //     position: relative;
            //     .swiper {
            //         position: absolute;
            //         top: 28%;
            //         .swiper-slide {
            //             width: 80%;
            //         }

            //         .width {
            //             width: 6%;
            //         }
            //     }
            // }
            // .layer4{
            //   img{
            //     width:100%;
            //   }
            // }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark-neo.vue